import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { SiteModel } from 'src/app/sites-builder/models/site.model';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-preview',
  templateUrl: './preview.component.html',
  styleUrls: ['./preview.component.scss'],
})
export class PreviewComponent implements OnInit {
  // From initial state: sb-manager/sb-list.component.ts
  public site: SiteModel;
  public url = null;
  public closeReason: 'success' | 'cancel';

  constructor(
    private bsModalRef: BsModalRef,
    private sanitizer: DomSanitizer
  ) {}

  ngOnInit(): void {
    this.url = this.sanitizer.bypassSecurityTrustResourceUrl(this.site.url);
  }

  public onDismiss(reason: 'cancel') {
    this.closeReason = reason;
    this.bsModalRef.hide();
  }
}
